module.exports = __webpack_public_path__ + "static/media/12b_hero_tablet.42b3a7ee.jpg";